/*
 * @Date: 2023-08-21 13:41:55
 * @LastEditors: chg
 * @desc: 白名单页面
 */

const whiteList = {
  namespaced: true, // 开启命名空间

  state: {
    vectorIdMap: null, // 向量ID和id集合的映射关系
    // 是否进行了选择因子的操作（公式问答-因子列表）
    isSelectFactor: false
  },

  mutations: {
    setVectorIdMap  (state, payload) {
      state.vectorIdMap = payload
    },
    // 是否进行了选择因子的操作（公式问答-因子列表）
    setIsSelectFactor (state, payload) {
      state.isSelectFactor = payload
    }
  }
}

export default whiteList



// WEBPACK FOOTER //
// ./src/store/whiteList.js